<script lang="ts" context="module">

    import QuestionText from "./QuestionText.svelte";
    import QuestionOptions from "./QuestionOptions.svelte";
    import QuestionGrid from "./QuestionGrid.svelte";

    const controlsMap = {
        text        : QuestionText,
        date        : QuestionText,
        bool        : QuestionOptions,
        multiple    : QuestionOptions,
        grid        : QuestionGrid,
    };

</script>

<script lang="ts">
    
    import type { Question } from "../../Model/Question";
    import Editable from "./Editable.svelte";

    export let question: Question;

</script>

<div class="question">
    <h6 class="fw-bold">
        <Editable store={question.name} />
    </h6>
    <svelte:component this={controlsMap[question.type]} {question} />
</div>

<style lang="scss">

    .question {
        position: relative;
        margin-top: 1.5rem;
        margin-left: -0.2rem;
        padding-left: 1rem;

        &::before {
            content: "";
            display: block;
            position: absolute;
            top: 0;
            left: 0;
            width: 4px;
            height: 100%;
            background-color: #ccc;
        }
    }

</style>
